import { GetAllSourcesListApiResponse } from "@common/types/data-source-types";
import { clientConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

export const getAllSourcesList = async (
  namespace: string,
): Promise<GetAllSourcesListApiResponse> => {
  const url = clientConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<GetAllSourcesListApiResponse>(
      `${url}/api/v3/ns/${namespace}/sources`,
      { headers },
    );

    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch all sources list. Please try again later.",
      );
    }

    throw new Error(
      "An unexpected error occurred while fetching all sources list.",
    );
  }
};
